module.exports = __webpack_public_path__ + "64af15d961059dfff55cbb76df73ff66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss23.jpg
// module id = 729
// module chunks = 0